import type { Router } from 'vue-router'

let sharedRouter: Router | undefined

export function setSharedRouter(router: Router) {
  sharedRouter = router
}

export function getSharedRouter(): Router {
  if (!sharedRouter) {
    throw new Error('Shared router not initialised - setSharedRouter must be called during app bootstrap')
  }
  return sharedRouter
}
